import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Templates = () => {
    document.title = "Şablonlar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Şablonlar", value: "/settings/templates", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Şablonlar</h2>
                    <p>
                        Sahibkar, məhsulların üzərinə barkod çap olunmuş stiker yapışdırmaq istədikdə barkod printerdə çap olunacaq şablonu seçməlidir
                        <br />
                        Ayarlar səhifəsində <mark>şablonlar</mark> seçimi edildikdən sonra <SaveButton /> düyməsini sıxmaq lazımdır.
                        <br />
                        Nümunədə şablonlar ilə əməliyyatlar göstərilib.
                    </p>
                    <img src="/images/settings/templates.gif" alt="Şablonlar" />
                </article>
            </div>
        </div>
    );
};
